import React, { useState } from "react";
import { Heart } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

/**
 * Reusable bookmark/favourite toggle button.
 * Props:
 *   appId         - the application ID
 *   initialState  - whether already favourited (boolean)
 *   onToggle      - optional callback(appId, newState)
 *   size          - icon size (default 16)
 *   className     - extra classes for the button element
 */
const BookmarkButton = ({ appId, initialState = false, onToggle, size = 16, className = "" }) => {
  const [saved, setSaved] = useState(initialState);
  const [loading, setLoading] = useState(false);

  const handleToggle = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/favourites/${appId}`, {}, { withCredentials: true });
      const newState = res.data.is_favourite;
      setSaved(newState);
      onToggle && onToggle(appId, newState);
    } catch {
      // Silently fail — user may not be logged in
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={loading}
      aria-label={saved ? "Remove from favourites" : "Save to favourites"}
      data-testid={`bookmark-btn-${appId}`}
      className={`p-1.5 rounded-lg transition-all hover:scale-110 focus:outline-none ${
        saved
          ? "text-red-500 hover:text-red-600"
          : "text-slate-300 hover:text-red-400"
      } ${className}`}
    >
      <Heart
        size={size}
        className={`transition-all ${saved ? "fill-red-500" : "fill-none"} ${loading ? "opacity-50" : ""}`}
      />
    </button>
  );
};

export default BookmarkButton;
